import { render, staticRenderFns } from "./WorkExampleDialog.vue?vue&type=template&id=45d5378a&scoped=true&"
import script from "./WorkExampleDialog.vue?vue&type=script&lang=js&"
export * from "./WorkExampleDialog.vue?vue&type=script&lang=js&"
import style0 from "./WorkExampleDialog.vue?vue&type=style&index=0&id=45d5378a&lang=scss&scoped=true&"
import style1 from "./WorkExampleDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d5378a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VResponsive})
